<div class="grid-container padding-y-4">
  <form [formGroup]="hhgCsvDownloadForm">
    <div class="grid-row grid-gap-1">
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
        <legend class="usa-legend usa-legend--large">
          HHG Rates Download
        </legend>
      </div>
    </div>

    <div class="grid-row grid-gap-1">
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
        <label for="effective_dates" class="usa-label">Rate Effective Dates<abbr title="required"
        class="usa-hint usa-hint--required">*</abbr></label>
        <select id="effective_dates" class="usa-select maxw-full" formControlName="effectiveDates"
          (change)="effectiveDatesChange($event.target.value)" required>
          <option value='' selected disabled>Choose...</option>
          @for (rateBidCycle of ratesBidcyclesList; track rateBidCycle) {
            <option [value]="rateBidCycle.ratesBidcyclesId">
              {{rateBidCycle.bidCycleName}} ( {{rateBidCycle.rateEffectiveDate | date:'mediumDate':'UTC'}} -
              {{rateBidCycle.rateExpiryDate | date:'mediumDate':'UTC'}} )
            </option>
          }
        </select>
      </div>
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
        <label for="effective_dates" class="usa-label">Transportation Type<abbr title="required"
        class="usa-hint usa-hint--required">*</abbr></label>
        <select id="effective_dates" class="maxw-full usa-select" formControlName="transType"
          (change)="transportationTypeChange()" required>
          <option value='' selected disabled>Choose...</option>
          @for (transportType of transportationList; track transportType) {
            <option [ngValue]="transportType">
              {{ transportType.Text }}
            </option>
          }
        </select>
      </div>
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
        <label for="rate-type" class="usa-label">Rate Type<abbr title="required"
        class="usa-hint usa-hint--required">*</abbr></label>
        <select id="rate-type" class="maxw-full usa-select" formControlName="rateType"
          (change)="rateTypeChange()" required>
          <option value='' selected disabled>Choose...</option>
          @for (rateType of rateTypeList; track rateType) {
            <option [ngValue]="rateType">{{rateType.Text}}</option>
          }
        </select>
      </div>
      @if (allTranScacFlag) {
        <div
          class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
          <p class="define-text-secondary">Note: If for "Transportation Type" either "All" or "International" is
            selected AND for "SCAC" either "All SCACs" or 10 or more SCACs are selected, you may not select "All
          Origins" and "All Destinations."</p>
        </div>
      }
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
        <label class="usa-label" for="scac">SCAC<abbr title="required"
        class="usa-hint usa-hint--required">*</abbr></label>
        <select id="scac" class="usa-select maxw-full define-height-usa-select" formControlName="scac" size="10"
          multiple (change)="scacChange($event.target.value)" required>
          <option value='' selected disabled>Choose...</option>
          <option value='-1'>All SCACs</option>
          @for (carrier of carrierList; track carrier) {
            <option [value]="carrier.carrierId">
              {{carrier.scac}} - {{carrier.scacName}}
            </option>
          }
        </select>
      </div>
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
        <label for="sro" class="usa-label">SRO<abbr title="required"
        class="usa-hint usa-hint--required">*</abbr></label>
        <select multiple id="sro" class="usa-select maxw-full define-height-usa-select" formControlName="sro"
          size="10" (change)="sroChange($event.target.value)" required>
          <option value='' selected disabled>Choose...</option>
          @for (sro of sroList; track sro) {
            <option [value]="sro.sroMasterId">
              {{sro.sroId}}
            </option>
          }
        </select>
      </div>

    </div>
    <div class="grid-row grid-gap-1">
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
        <label for="origin" class="usa-label">Origin<abbr title="required"
        class="usa-hint usa-hint--required">*</abbr></label>
        <select id="origin" class="maxw-full usa-select" formControlName="origin"
          (change)="originChange($event.target.value)" required>
          <option value='' selected disabled>Choose...</option>
          <option value='0'>All Origins</option>
          @for (origin of origin$|async; track origin) {
            <option [value]="origin.stateCountryId">
            {{origin.stateCountryCode}} - {{origin.stateCountryName }}</option>
          }
        </select>
      </div>
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
        <label class="usa-label" for="destination">Destination<abbr title="required"
        class="usa-hint usa-hint--required">*</abbr></label>
        <select id="destination" class="maxw-full usa-select" formControlName="destination"
          (change)="destinationChange($event.target.value)" required>
          <option value='' selected disabled>Choose...</option>
          @if (testAllDest) {
            <option value='0'>All Destinations</option>
          }
          @for (destination of destination$|async; track destination) {
            <option [value]="destination.stateCountryId">
            {{destination.stateCountryCode}} - {{destination.stateCountryName }}</option>
          }
        </select>
      </div>
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 padding-top-2">
                <button class="usa-button" [disabled]="!(controlChanged && 
                                           rateTypeChanged && 
                                           scacChanged && 
                                           sroChanged && 
                                           originChanged && 
                                           destinationChanged &&
                                           transportationTypeChange &&
                                           !allOrigDestFlag)" (click)="download()">
        Download</button>


                <!-- <button class="usa-button" [disabled]="!(controlChanged && 
                            rateTypeChanged && 
                            scacChanged && 
                            sroChanged && 
                            originChanged && 
                            destinationChanged &&
                            transportationTypeChange &&
                            !allOrigDestFlag)" (click)="download2()"> Download-cursor</button>
                <button class="usa-button" [disabled]="!(controlChanged && 
                            rateTypeChanged && 
                            scacChanged && 
                            sroChanged && 
                            originChanged && 
                            destinationChanged &&
                            transportationTypeChange &&
                            !allOrigDestFlag)" (click)="downloadMultiThread()"> Download-multithread</button> -->
    </div>
  </div>
</form>
</div>